import { render, staticRenderFns } from "./ClassTrial.vue?vue&type=template&id=05405fde&scoped=true"
import script from "./ClassTrial.vue?vue&type=script&lang=js"
export * from "./ClassTrial.vue?vue&type=script&lang=js"
import style0 from "./ClassTrial.vue?vue&type=style&index=0&id=05405fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05405fde",
  null
  
)

export default component.exports